export default __webpack_public_path__ + "static/media/inseeLogo.54b89f79.png";